import { t } from '@lingui/core/macro';
import { FacilityTransferDirection, WheelExternalCheckStatus } from '@navio/nsdk';

// The receiving facility sees the sender's answers, so its labels say whose answer it is.
export const getExternalCheckStatusLabel = (
  status: WheelExternalCheckStatus,
  direction: FacilityTransferDirection
): string => {
  const isIncoming = direction === FacilityTransferDirection.INCOMING;
  switch (status) {
    case WheelExternalCheckStatus.READY:
      return isIncoming ? t`Ready at sender` : t`Marked as ready`;
    case WheelExternalCheckStatus.ISSUE:
      return isIncoming ? t`Issue at sender` : t`Issue`;
    case WheelExternalCheckStatus.PENDING:
      return isIncoming ? t`Awaiting sender` : t`Awaiting check`;
  }
};
